(function () {'use strict';}());
angular.module("app").directive('mainMenuView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/main-menu.html?version=1.0',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
      }  
    };
  });